<template>
  <div class="grid-x flex-grow object-editor-layout">
    <div class="cell large-7 cell-block-y padding-2">
      <div class="grid-y space-y-12">
        <div class="cell flex flex-col">
          <b class="text-16px leading-18px title-divided self-start">
            Информация о семейном захоронении
          </b>
          <div class="grid-x grid-padding-x -mx-4 mt-6">
            <div class="cell auto flex flex-col space-y-4">
              <Input
                label="Название"
                placeholder="Введите название захоронения"
                classes="bg-hint border-none"
                v-model="model.name"/>
            </div>
            <div class="cell auto"></div>
          </div>
        </div>
        <div class="cell">
          <ObjectFamilyPhoto
            v-model="model.photoAttach"/>
        </div>
        <div class="cell">
          <ObjectLocation
            :type="'family'"
            :total="total"
            v-model="model.location"/>
        </div>
        <div class="cell">
          <ObjectBurials
            :type="'family'"
            :update="model.updateBurials"
            :create="model.createBurials"
            @update-input="($event) => model.updateBurials = $event"
            @create-input="($event) => model.createBurials = $event"/>
        </div>
      </div>
    </div>
    <div class="cell large-5 cell-block-y padding-2 flex flex-col">
      <ObjectAbout
        v-model="model.about"
        @cancel="$router.push({
          name: 'objects',
        })"
        @save="save"/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Input from '@/components/Input.vue';
import ObjectLocation from '@/pages/Objects/ObjectNew/Components/ObjectLocation.vue';
import ObjectBurials from '@/pages/Objects/ObjectNew/Components/ObjectBurials.vue';
import ObjectAbout from '@/pages/Objects/ObjectNew/Components/ObjectAbout.vue';
import ObjectFamilyPhoto from '@/pages/Objects/ObjectNew/Components/ObjectFamilyPhoto.vue';

export default {
  components: {
    Input,
    ObjectLocation,
    ObjectBurials,
    ObjectAbout,
    ObjectFamilyPhoto,
  },
  props: {
    payload: {
      type: Object,
      required: false,
      default: () => ({
        name: '',
        location: {
          country: null,
          region: null,
          district: null,
          cemetery: null,
          fence: null,
          size: null,
          section: '',
          crypt: '',
        },
        updateBurials: [],
        createBurials: [],
        about: {
          celebrity: false,
          order: true,
        },
        photoAttach: [],
      }),
    },
  },
  data() {
    return {
      model: this.payload,
    };
  },
  computed: {
    query() {
      return {
        name: this.model.name,
        family: true,
        ...this.model.location,
        ...this.model.about,
        createBurials: this.model.createBurials,
        updateBurials: this.model.updateBurials,
        photoAttach: this.model.photoAttach,
      };
    },
    total() {
      const update = +(_.get(this.model, 'updateBurials') || []).length;
      const create = +(_.get(this.model, 'createBurials') || []).length;
      return update + create;
    },
  },
  methods: {
    save() {
      this.$emit('save', this.query);
    },
  },
};
</script>
